import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {BsModalRef, BsModalService, ModalOptions} from "ngx-bootstrap/modal";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {DetailService} from "../../../../services/details/detail.service";
import {ToastrService} from "ngx-toastr";
import {HelperService} from "../../../../services/helperService";
import {TranslateService} from "@ngx-translate/core";
import {ActivatedRoute} from "@angular/router";
import {Field} from "../../models/field.model";
import {AuthService} from "../../../../services";

@Component({
  selector: 'tig-form-leadexport',
  templateUrl: './form-leadexport.component.html',
  styleUrls: ['./form-leadexport.component.scss']
})
export class FormLeadexportComponent extends Field implements OnInit {

	public static IFRAME_ID = 'iframe-leadexport';

	/**
	 * Attributes
	 */
	// Referenz auf den iFrame
	@ViewChild('OBJ_model_iframe', {static:false}) OBJ_model_iframe;
	public OBJ_iframe_content: SafeHtml = "<div>Loading...</div>";
	private OBJ_iframe_ref: BsModalRef;
	private STR_id = "";

	/**
	 * @param {Ng4LoadingSpinnerService} OBJ_spinner_service
	 * @param OBJ_detail_service
	 * @param OBJ_sanitizer
	 * @param OBJ_toastr_service
	 * @param OBJ_modal_service
	 * @param OBJ_helper_service
	 * @param OBJ_translate_service
	 * @param OBJ_route
	 * @param OBJ_auth_service
	 */
	constructor(
		private OBJ_spinner_service: Ng4LoadingSpinnerService,
		private OBJ_detail_service: DetailService,
		private OBJ_sanitizer: DomSanitizer,
		private OBJ_toastr_service: ToastrService,
		private OBJ_modal_service: BsModalService,
		private OBJ_helper_service: HelperService,
		private OBJ_translate_service: TranslateService,
		private OBJ_route: ActivatedRoute,
		private OBJ_auth_service: AuthService
	)
	{
		super();
	} // end constructor

	// TODO: Only show button when certain fields are filled
	ngOnInit(): void
	{
		this.STR_id = this.OBJ_route.snapshot.paramMap.get('id');
	}

	/**
	 * Function > onMessage
	 * @desc Listen to messages from iframe
	 *
	 * @param event
	 */
	@HostListener('window:message', ['$event'])
	onMessage(event)
	{
		if(event.source.frameElement && event.source.frameElement.id === FormLeadexportComponent.IFRAME_ID)
		{
			this.receiveMessageFromIFrame(event);
		}
	} // end function onMessage



	/**
	 * Function > closeEditorWithoutSaving
	 */
	closeIFrame() {
		this.OBJ_iframe_ref.hide();
	}


	/**
	 * Function > openIFrame
	 */
	openIFrame(OBJ_btn: HTMLElement)
	{
		// disable button and show the spinner
		OBJ_btn.setAttribute('disabled', 'disabled');
		this.OBJ_spinner_service.show();

		this.OBJ_detail_service.getIFrame(this.OBJ_field_config._links.iframe.href).subscribe(
			OBJ_response => {
				this.OBJ_iframe_content = this.OBJ_sanitizer.bypassSecurityTrustHtml(OBJ_response);
				let OB_modal_options = new ModalOptions();
				OB_modal_options.ignoreBackdropClick = true;
				OB_modal_options.class ='tig-modal-formbuilder';

				// Zeige Modal an
				this.OBJ_iframe_ref = this.OBJ_modal_service.show(this.OBJ_model_iframe, OB_modal_options);
				OBJ_btn.removeAttribute('disabled');
			},
			OBJ_error => {
				this.OBJ_toastr_service.error(this.OBJ_translate_service.instant("oError.sIFrame"));
			},
			() => {
				// hide spinner
				this.OBJ_spinner_service.hide();
			});

	} // end function openIFrame


	/**
	 * Function > receiveMessageFromIFrame
	 *
	 * @desc reagiere auf postmessage des iFrames
	 * @param event
	 */
	receiveMessageFromIFrame(event)
	{

		try
		{

			// try to parse the event we got
			let OBJ_data = JSON.parse(event.data);

			// iFrame is loaded and tells us that its ready to receive data
			if(OBJ_data.event === 'ready')
			{
				// post message to iFrame
				let OBJ_msg =
					{
						"event": "config",
						"id": this.STR_id,
						"access_token": this.OBJ_helper_service.getFromLocalstorage('access').access_token,
						"refresh_token": this.OBJ_helper_service.getFromLocalstorage('access').refresh_token
					};
				// Post data to iFrame
				event.source.postMessage(JSON.stringify(OBJ_msg), "*");
			} // end if
			else if (OBJ_data.event == 'generate_hash')
			{
				let OBJ_hash = this.OBJ_helper_service.generateHash(OBJ_data.params, OBJ_data.body, this.OBJ_auth_service.getToken("access_token"));
				// Post data to iFrame
				event.source.postMessage(OBJ_hash, event.origin);

			} // end if

		}
		catch (e) {
			// Not the event we are looking for, no need to take action
		} // end try/catch

	} // end function receiveMessageFromIFrame


	/**
	 * Function > getIFrameID
	 */
	public getIFrameID()
	{
		return FormLeadexportComponent.IFRAME_ID;
	} // end function getIFrameID


} // end class FormLeadexportComponent
